<!--<menu></menu>-->
<!-- Info Banner -->
<!-- <np-info-popup></np-info-popup> -->
<router-outlet></router-outlet>
